import {Card, Col, Row, Statistic} from 'antd';
import {StatisticProps} from 'antd/lib/statistic/Statistic';
import {Stats} from 'api/generated';
import {colors} from 'lib/colors';
import React from 'react';
import {formatAmount} from '../../lib/formaters';
import moment from 'moment';

type Props = {stats: Stats | null | undefined; loading?: boolean};

export const AccountStatsTable: React.FC<Props> = ({stats, loading}) => {
  const properties: StatisticProps[] = [
    {
      title: 'Active',
      value: moment.duration(stats?.activeMonths, 'month').humanize()
    },
    {
      title: 'Avg monthly volume',
      value: stats?.avgMonthlyVolume || 0,
      // @ts-ignore
      formatter: (value: number) => formatAmount(value, 'EUR', 0)
    },
    {
      title: 'Avg transactions per month',
      value: stats?.avgMonthlyTransactions || 0
    },
    {
      title: 'Total transactions',
      value: stats?.totalSucceededCount || 0
    },
    {
      title: 'Total gross volume',
      value: stats?.totalSucceededAmount || 0,
      // @ts-ignore
      formatter: (value: number) => formatAmount(value, 'EUR', 0)
    }
  ];

  return (
    <Row gutter={16} style={{marginBottom: 20}}>
      {properties.map((prop, i) => (
        <Col key={i} flex="auto">
          <Card bodyStyle={{padding: 12}} loading={loading}>
            <Statistic {...prop} valueStyle={{color: colors.primary}} />
          </Card>
        </Col>
      ))}
    </Row>
  );
};
